import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shell } from "@/pages/ForgotPassword";
import { PasswordChecklist, PW_RULES } from "@/pages/ResetPassword";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const navigate = useNavigate();
  const { user, changePassword } = useAuth();
  const forced = user?.must_change_password;
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const valid = PW_RULES.every((r) => r.test(pw)) && pw === confirm && current;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== confirm) return setError("Passwords do not match");
    setLoading(true);
    const res = await changePassword(current, pw);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <Shell
      title={forced ? "Set your password" : "Change password"}
      subtitle={forced ? "For security, set a new password before continuing." : "Update your account password."}
    >
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label>{forced ? "Temporary password" : "Current password"}</Label>
          <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </div>
        <div className="space-y-1.5">
          <Label>New password</Label>
          <Input data-testid="cp-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required />
        </div>
        <PasswordChecklist value={pw} />
        <div className="space-y-1.5">
          <Label>Confirm new password</Label>
          <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </div>
        {error && <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700 ring-1 ring-red-200" data-testid="cp-error">{error}</div>}
        <Button type="submit" className="w-full" disabled={loading || !valid} data-testid="cp-submit">
          {loading ? "Saving…" : "Save password"}
        </Button>
        {!forced && (
          <Button type="button" variant="outline" className="w-full" onClick={() => navigate(-1)}>Cancel</Button>
        )}
      </form>
    </Shell>
  );
}
